import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'

export default function HealthAndSafetySection() {
    return (
        <div className='health-and-safety-section d-flex flex-column align-items-start justify-content-center'>
            <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                <h3 style={{ fontWeight: '800', fontSize: '2em', color: '#122E31', textAlign: 'start' }}>Health & Safety</h3>
            </AnimationOnScroll>
            <AnimationOnScroll duration={2} delay={100} animateIn="animate__slideInUp">
                <p align='left' style={{ fontWeight: '500', fontSize: '1.5em' }}>Responsibility is a solid part of our business and we<br />
                    have set our standards high. We offer high quality<br />
                    products that are safe, sustainable, durable and carry<br />
                    third-party certifications.</p>
            </AnimationOnScroll>
        </div>
    )
}
